import React, { useEffect } from "react";

const FlodeskForm = () => {
  useEffect(() => {
    // Function to load the Flodesk script
    const loadFlodeskScripts = () => {
      const scriptModule = document.createElement("script");
      const scriptNoModule = document.createElement("script");

      const scriptBaseURL = "https://assets.flodesk.com/universal";
      const versionSuffix = `?v=${
        Math.floor(new Date().getTime() / (120 * 1000)) * 60
      }`;

      // Module script
      scriptModule.type = "module";
      scriptModule.src = `${scriptBaseURL}.mjs${versionSuffix}`;
      scriptModule.async = true;

      // No-module script
      scriptNoModule.noModule = true;
      scriptNoModule.src = `${scriptBaseURL}.js${versionSuffix}`;
      scriptNoModule.async = true;

      // Append scripts to the document
      document.body.appendChild(scriptModule);
      document.body.appendChild(scriptNoModule);

      // Cleanup: remove scripts on unmount
      return () => {
        document.body.removeChild(scriptModule);
        document.body.removeChild(scriptNoModule);
      };
    };

    // Execute the Flodesk initialization
    loadFlodeskScripts();

    // Initialize the Flodesk form
    window.fd =
      window.fd ||
      function () {
        (window.fd.q = window.fd.q || []).push(arguments);
      };
    window.fd("form", {
      formId: "6777881d7b52e841497328a4", // Replace with your form ID
      containerEl: "#fd-form-6777881d7b52e841497328a4",
    });
  }, []);

  return (
    <div>
      <div id="fd-form-6777881d7b52e841497328a4"></div>
    </div>
  );
};

export default FlodeskForm;
